export default __webpack_public_path__ + "static/media/his6.e7b699b2.jpg";